module.exports = __webpack_public_path__ + "img/classPhotoes.3723ddc1.svg";